import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import Alert from 'components/icons/alert';

import s from 'components/badge/badge.sss';

export default class Badge extends Component {
	render(props) {
		const hasChildren = Array.isArray(props.children) ? props.children.length : !!props.children;
		return (
			<div class={joinClasses(s.badge, props.dark && s.dark, s[`badge-${props.type}`], props.class)}>
				{!!props.alert && <Alert />}
				{hasChildren ? props.children : props.type}
			</div>
		);
	}
}